(function(){
  'use strict';

  if(window.__syCommerceFeedbackBound) return;
  window.__syCommerceFeedbackBound = true;

  var doc=document;
  var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(el, classes) {
    if (!el || reduce) return;
    classes.forEach(function (name) { el.classList.remove(name); });
    void el.offsetWidth;
    classes.forEach(function (name) { el.classList.add(name); });
    var done = function () {
      classes.forEach(function (name) { el.classList.remove(name); });
    };
    el.addEventListener('animationend', done, { once: true });
    window.setTimeout(done, 900);
  }

  function findAddButton(event) {
    if (!(event.target instanceof Element)) return null;
    return event.target.querySelector('[ref="addToCartButton"], button[name="add"]');
  }

  // --- Continuous "adding…" pending state ---------------------------------
  // The stock optimistic checkmark (data-added) reverts after ~800ms, but on
  // this store an add round-trips in ~2-3s (Shopify /cart/add.js + cart
  // refresh). That gap leaves the button looking idle for ~2s, which reads as
  // "nothing happened" and provokes duplicate clicks. We hold a visible
  // pending state on the clicked add button from pointer-down until the
  // cart-lines-update promise settles (success OR error — product-form settles
  // that same promise in every path). UI-only; no cart/mutation logic touched.
  function markPending(btn) {
    if (!btn) return;
    btn.classList.add('sy-atc--pending');
    window.clearTimeout(btn.__syPendingTimer);
    // Failsafe: never strand the spinner if no settle event ever arrives.
    btn.__syPendingTimer = window.setTimeout(function () {
      btn.classList.remove('sy-atc--pending');
    }, 12000);
  }

  function clearPending() {
    doc.querySelectorAll('.sy-atc--pending').forEach(function (btn) {
      window.clearTimeout(btn.__syPendingTimer);
      btn.classList.remove('sy-atc--pending');
    });
  }

  function onAddPointerDown(event) {
    if (!(event.target instanceof Element)) return;
    var btn = event.target.closest('button[name="add"], [ref="addToCartButton"]');
    if (!btn || btn.disabled) return;
    var form = btn.closest('form');
    if (form && typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    markPending(btn);
  }

  function cartRowKeys(event, result) {
    var lines = event.lines || [];
    if (event.action !== 'add') {
      return lines.map(function (line) { return String(line.id); });
    }
    var variantIds = lines.map(function (line) { return String(line.merchandiseId); });
    var items = result.detail && result.detail.items || [];
    return items.filter(function (item) {
      return variantIds.indexOf(String(item.variant_id)) !== -1;
    }).map(function (item) { return String(item.key); });
  }

  function highlightRows(keys, attempts) {
    var found = false;
    doc.querySelectorAll('cart-items-component[data-drawer] .cart-items__table-row[data-key]').forEach(function (row) {
      if (keys.indexOf(row.dataset.key) === -1) return;
      found = true;
      play(row, ['sy-cart-row--updated']);
    });
    if (!found && attempts > 0) {
      window.requestAnimationFrame(function () { highlightRows(keys, attempts - 1); });
    }
  }

  function onCartUpdate(event) {
    if (!event.promise || (event.action !== 'add' && event.action !== 'update')) return;
    var addButton = event.action === 'add' ? findAddButton(event) : null;
    event.promise.then(function (result) {
      clearPending();
      if (result.detail && result.detail.didError) return;
      if (addButton) play(addButton, ['sy-atc--added']);
      var keys = cartRowKeys(event, result);
      if (keys.length) highlightRows(keys, 8);
    }).catch(function (error) {
      clearPending();
      if (!error || error.name !== 'AbortError') console.warn('[sy-commerce-feedback]', error);
    });
  }

  function watchCartCounts(scope) {
    if (reduce || !('MutationObserver' in window)) return;
    var root = scope && scope.querySelectorAll ? scope : doc;
    root.querySelectorAll('[ref="cartBubbleCount"], .cart-bubble__text-count').forEach(function (count) {
      if (count.dataset.syCommerceCount) return;
      count.dataset.syCommerceCount = '1';
      new MutationObserver(function () {
        play(count, ['is-bumped', 'sy-badge-pop']);
      }).observe(count, { childList: true, characterData: true, subtree: true });
    });
  }

  function onVariantChange(event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !input.closest('variant-picker')) return;
    play(input.closest('label'), ['is-just-selected', 'sy-chip']);
  }

  // Cart-drawer carousels (pairs / offers) latch vertical wheel gestures in
  // Chrome even though they only scroll horizontally, so the drawer can't be
  // scrolled from those regions. Redirect vertical wheel deltas over a
  // carousel to the drawer's items scroller; horizontal deltas are left alone
  // so trackpad swipes still drive the carousel. One listener on the stable
  // #cart-drawer host (survives content morphs) — no global wheel handler.
  function bindCarouselWheel() {
    var drawer = doc.getElementById('cart-drawer');
    if (!drawer || drawer.dataset.syWheelBound) return;
    drawer.dataset.syWheelBound = '1';
    drawer.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
      if (!(e.target instanceof Element)) return;
      if (!e.target.closest('.sy-cart-pairs__rail, .sy-offers__stack')) return;
      var items = drawer.querySelector('.cart-drawer__items');
      if (!items) return;
      e.preventDefault();
      items.scrollBy({ top: e.deltaY });
    }, { passive: false });
  }

  // Price settle: when a <product-price> re-renders (variant switch), the number
  // teleports at the exact moment the shopper is looking at it. A scoped observer
  // per price element pulses a transient fade-in class when — and only when — the
  // visible text actually changes. play() supplies reduced-motion + cleanup.
  function watchPrices(scope) {
    if (reduce || !('MutationObserver' in window)) return;
    var root = scope && scope.querySelectorAll ? scope : doc;
    root.querySelectorAll('product-price').forEach(function (price) {
      if (price.dataset.syPriceWatch) return;
      price.dataset.syPriceWatch = '1';
      var last = price.textContent;
      new MutationObserver(function () {
        if (price.textContent === last) return; // attribute-only churn — ignore
        last = price.textContent;
        play(price, ['sy-price--updated']);
      }).observe(price, { childList: true, subtree: true, characterData: true });
    });
  }

  function initHero(hero) {
    if (hero.dataset.syFeedbackHero) return;
    hero.dataset.syFeedbackHero = '1';
    var track = hero.querySelector('[data-sy-hero-track]');
    var slides = Array.from(hero.querySelectorAll('[data-sy-hero-slide]'));
    if (!track || !slides.length) return;
    var active = -1;
    var scheduled = false;
    var sync = function () {
      scheduled = false;
      var index = Math.min(Math.max(Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)), 0), slides.length - 1);
      if (index === active) return;
      active = index;
      slides.forEach(function (slide, slideIndex) { slide.classList.toggle('is-active', slideIndex === index); });
      var steps = slides[index].querySelectorAll('.sy-reveal');
      if (reduce || !doc.documentElement.classList.contains('sy-motion')) {
        steps.forEach(function (step) { step.classList.add('is-revealed'); });
        return;
      }
      steps.forEach(function (step) { step.classList.remove('is-revealed'); });
      window.requestAnimationFrame(function () {
        steps.forEach(function (step) { step.classList.add('is-revealed'); });
      });
    };
    track.addEventListener('scroll', function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(sync);
    }, { passive: true });
    sync();
  }

  function init(scope) {
    watchCartCounts(scope);
    watchPrices(scope);
    bindCarouselWheel();
    var root = scope && scope.querySelectorAll ? scope : doc;
    if (root.nodeType === 1 && root.matches('[data-sy-hero]')) initHero(root);
    root.querySelectorAll('[data-sy-hero]').forEach(initHero);
  }

  doc.addEventListener('shopify:cart:lines-update', onCartUpdate);
  doc.addEventListener('pointerdown', onAddPointerDown, true);
  doc.addEventListener('change', onVariantChange);
  doc.addEventListener('shopify:section:load', function (event) { init(event.target); });
  init(doc);
})();
